import { Injectable } from '@angular/core';
import { Urls } from '@core/config/urls';
import { LegacyBaseApiService } from '@smartera/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class WorkflowStatusService extends LegacyBaseApiService<any> {
	public masterId: string;
	public set _apiUrl(value) {}

	public override get apiUrl() {
		return `${Urls.BASE_URL.toString()}/callcenter/workflows/${this.masterId}/statuses`;
	}

	public getStatusTransaction(statusId: string): Observable<any> {
		return this._restClientService
			.post(`${this.apiUrl}/${statusId}/transactions/search`, '{}')
			.pipe(map((res) => res.content));
	}
	public deleteTransaction(statusId: string, transId: string): Observable<any> {
		return this._restClientService.delete(`${this.apiUrl}/${statusId}/transactions/${transId}`);
	}
}
